module.exports = __webpack_public_path__ + "img/75584.4d8b05d9.svg";